export const playlistNameInputDataSet = { cy: 'playlist-input-name' };
